import React from "react";
import { EventMutateProvider } from "../../../../contexts/events.context";
import EventInfo from "./components/EventInfo";

const EditEvent = () => {
  return (
    <EventMutateProvider>
      <EventInfo />
    </EventMutateProvider>
  );
};
export default EditEvent;
